<template>
  <button
    class="button love-button is-transparent"
    :class="[{ 'is-loved': loved }, size]"
    @click="toggle"
  >
    <span class="loves-count" :class="textColor">{{ lovesCount }}</span>
    <b-icon class="loved-icon" :size="size" :icon="icon" :type="color"></b-icon>
    <b-icon
      class="unloved-icon"
      :size="size"
      :icon="icon + '-outline'"
      :type="color"
    ></b-icon>
  </button>
</template>

<script>
export default {
  props: {
    count: {
      type: Number
    },

    value: {
      type: Boolean,
      default: false
    },

    type: {
      type: String,
      required: true
    },

    id: {
      type: String,
      required: true
    },

    icon: {
      type: String,
      default: "heart"
    },

    textColor: {
      type: String,
      default: "has-text-grey"
    },

    size: {
      type: String
    },

    color: {
      type: String,
      default: "is-danger"
    }
  },

  data() {
    return {
      lovesCount: this.count,
      loved: this.value,
      form: new window.Form({
        likeable_type: this.type,
        likeable_id: this.id
      })
    };
  },

  computed: {
    active() {
      return this.$store.getters.signedIn;
    }
  },

  watch: {
    value(value) {
      this.loved = value;
    }
  },

  methods: {
    save() {
      this.form.submit(this.loved ? "post" : "delete", "/api/likes");
    },

    toggle() {
      if (this.active) {
        this.loved = !this.loved;

        this.lovesCount += this.loved ? 1 : -1;

        this.save();
      } else {
        this.$buefy.toast.open(
          "Та таалагдсан дарахын тулд эхлээд нэвтэрнэ үү."
        );
      }
    }
  }
};
</script>
